module.exports = "/images/ss-wordmark-black.png?f071b8911d1331a89a684864564b2b6f";